import React, { Component } from 'react';
import { func } from 'prop-types';

/**
 * Handling input IME mode. When user is still composing,
 * do not update redux form value.
 */
const ImeEnhancer = ComposedComponent =>
  class _Enhancer extends Component {
    static propTypes = {
      onChange: func.isRequired,
    };

    constructor(props) {
      super(props);
      this.isComposing = false;
    }

    handleChange = (value, evt) => {
      const { onChange } = this.props;
      const { isComposing } = this;

      if (!evt.target instanceof HTMLInputElement || isComposing) return;

      // onChange from redux form.
      onChange(value, evt);
    };

    handleComposition = evt => {
      if (evt.type === 'compositionend') {
        this.isComposing = true;
        this.handleChange(evt);
      } else {
        this.isComposing = false;
      }
    };

    render() {
      return (
        <ComposedComponent
          {...this.props}
          onChange={this.handleChange}
          onCompositionStart={this.handleComposition}
          onCompositionUpdate={this.handleComposition}
          onCompositionEnd={this.handleComposition}
        />
      );
    }
  };

export default ImeEnhancer;



// WEBPACK FOOTER //
// ./app/components/fields/ImeEnhancer/ImeEnhancer.jsx